module.exports = __webpack_public_path__ + "img/bannerImg.17ce37a9.png";